import './maintenance.scss';
import {useGetMaintenance} from "../../../api/general/useGetMaintenance";
import CloseIcon from '../../../assets/icons/UI/icons/close.svg';
import { useState } from 'react';

const MaintenanceBanner = () => {
  const [showBanner, setShowBanner] = useState<boolean>(true);
  const {data: maintenance} = useGetMaintenance();

  if (maintenance?.show_banner && showBanner) {
    return <div className={'maintenance'}>
      <img
        src={CloseIcon}
        alt={'close'}
        onClick={() => setShowBanner(false)}
        className={'maintenance-close'}
      />

      <div className={'maintenance-title'}>
        Upcoming System Maintenance:
      </div>
      <div className={'maintenance-text'}>
        {maintenance.banner_text}
      </div>

    </div>
  }

  return null;
}

export default MaintenanceBanner;